import {
	FLOW_ADMIN_DETAIL_CHANGE_FLOW_ACTION,
	FETCH_FLOW_ADMIN_DETAIL_INIT,
 	FETCH_FLOW_ADMIN_DETAIL_SUCCESS,
 	FETCH_FLOW_ADMIN_DETAIL_FAILURE,
  BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_INIT,
  BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_SUCCESS,
  BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_FAILURE,  
	FLOW_ADMIN_DETAIL_VALIDATE_FLOW_INIT,
	FLOW_ADMIN_DETAIL_VALIDATE_FLOW_SUCCESS,
	FLOW_ADMIN_DETAIL_VALIDATE_FLOW_FAILURE,
  FLOW_ADMIN_DETAIL_VALIDATE_FLOW_RESET,
  FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_INIT,
  FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_SUCCESS,
  FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_FAILURE,
  FLOW_ADMIN_DETAIL_SAVE_STATS_INIT,
  FLOW_ADMIN_DETAIL_SAVE_STATS_SUCCESS,
  FLOW_ADMIN_DETAIL_RESET
 } from './types';
 import API from './api';

export function reset() {
  return {
    type: FLOW_ADMIN_DETAIL_RESET,
  };
}

 export function changeFlowAction(modifiedFlow, action, comment) {
 	return {
 		type: FLOW_ADMIN_DETAIL_CHANGE_FLOW_ACTION,
 		payload: {
			modifiedFlow: {...modifiedFlow},
			action: action,
			comment: comment
 		},
 	};
 }

 function fetchApiSuccess(data) {
 	return {
 		type: FETCH_FLOW_ADMIN_DETAIL_SUCCESS,
 		payload: data,
 	};
 }

 function fetchApiFailure(error) {
 	console.log(error)
 	return {
 		type: FETCH_FLOW_ADMIN_DETAIL_FAILURE,
 		payload: error,
 	};
 }

 function fetchApiInit() {
 	return {
 		type: FETCH_FLOW_ADMIN_DETAIL_INIT,
 	};
 }

 export function fetchFlowAdminDetailApi(filters) {
 	return async (dispatch) => {
 		dispatch(fetchApiInit());
 		try {
 			let data = await API.data.getAll(filters);
 			dispatch(fetchApiSuccess(data));
 		} catch (error) {
 			dispatch(fetchApiFailure(error));
 		}
 	};
 }

 /* background fetch */

 function backgroundFetchApiSuccess(data) {
  return {
    type: BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_SUCCESS,
    payload: data,
  };
 }

 function backgroundFetchApiFailure(error) {
  console.log(error)
  return {
    type: BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_FAILURE,
    payload: error,
  };
 }

 function backgroundFetchApiInit() {
  return {
    type: BACKGROUND_FETCH_FLOW_ADMIN_DETAIL_INIT,
  };
 }

 export function backgroundFetchFlowAdminDetailApi(filters) {
  return async (dispatch) => {
    dispatch(backgroundFetchApiInit());
    try {
      let data = await API.data.getAll(filters);
      dispatch(backgroundFetchApiSuccess(data));
    } catch (error) {
      dispatch(backgroundFetchApiFailure(error));
    }
  };
 }

 /* Validate Flow (Async) */

function validateFlowApiSuccess(data) {
  return {
    type: FLOW_ADMIN_DETAIL_VALIDATE_FLOW_SUCCESS,
    payload: data
  };
}

function validateFlowApiFailure(error) {
  return {
    type: FLOW_ADMIN_DETAIL_VALIDATE_FLOW_FAILURE,
    payload: error
  };
}

function validateFlowApiInit() {
  return {
    type: FLOW_ADMIN_DETAIL_VALIDATE_FLOW_INIT
  };
}

export function validateFlow(flowData) {
  return async dispatch => {
    dispatch(validateFlowApiInit());
    try {
      const resp = await API.data.validateFlow(flowData);
      return dispatch(validateFlowApiSuccess(resp));
    } catch (error) {
      return dispatch(validateFlowApiFailure(error));
    }
  };
}

export function validateFlowApiReset() {
  return {
    type: FLOW_ADMIN_DETAIL_VALIDATE_FLOW_RESET
  };
}

 /* Save Flow Actions (Async) */

function saveFlowActionsApiSuccess(data) {
  return {
    type: FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_SUCCESS,
    payload: data
  };
}

function saveFlowActionsApiFailure(error) {
  return {
    type: FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_FAILURE,
    payload: error
  };
}

function saveFlowActionsApiInit() {
  return {
    type: FLOW_ADMIN_DETAIL_SAVE_FLOW_ACTIONS_INIT
  };
}

export function saveFlowActions(flowsActions) {
  return async dispatch => {
    dispatch(saveFlowActionsApiInit());
    try {
      const resp = await API.data.saveFlowActions(flowsActions);
      return dispatch(saveFlowActionsApiSuccess(resp));
    } catch (error) {
      return dispatch(saveFlowActionsApiFailure(error));
    }
  };
}

 /* Save Stats (Async) */

function saveStatsApiSuccess(data) {
  return {
    type: FLOW_ADMIN_DETAIL_SAVE_STATS_SUCCESS,
    payload: data
  };
}

function saveStatsApiFailure(error) {
  return {
    type: FLOW_ADMIN_DETAIL_SAVE_STATS_FAILURE,
    payload: error
  };
}

function saveStatsApiInit() {
  return {
    type: FLOW_ADMIN_DETAIL_SAVE_STATS_INIT
  };
}

export function saveStats(stats) {
  return async dispatch => {
    dispatch(saveStatsApiInit());
    try {
      const resp = await API.data.saveStats(stats);
      return dispatch(saveStatsApiSuccess(resp));
    } catch (error) {
      return dispatch(saveStatsApiFailure(error));
    }
  };
}

export function downloadTodayReport(filter) {
  return async (dispatch) => {
    try {
      let data = await API.data.handleDownloadTodayReport(filter);
    } catch (error) {}
  };
}

 export function downloadMopFile(path) {
  return async (dispatch) => {
    try {
      let data = await API.data.handleDownloadMopFile(path);
    } catch (error) {}
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/flow_admin_detail/index.js